/**
 * throttle function
 * Borrowed from underscore;
 */
import debounce from './debounce';

let throttle = function (func, wait) {
    let context, args, timeout, throttling, more, result;
    let whenDone = debounce(() => {
        more = throttling = false;
    }, wait);
    return function () {
        context = this; args = arguments;
        let later = function () {
            timeout = null;
            if (more) { func.apply(context, args); }
            whenDone();
        };
        if (!timeout) { timeout = setTimeout(later, wait); }
        if (throttling) {
            more = true;
        } else {
            result = func.apply(context, args);
        }
        whenDone();
        throttling = true;
        return result;
    };
};

export default throttle;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/packages/throttle.js